<template>
  <div class="home-page">
    <div class="home_mobile">
      <!-- <a class="openapp" :href="this.$config.iOSAPPUrl">Open app</a> -->
      <div><img class="logo" src="/public/lmk_text@2x.png" /></div>
      <h1 class="title">Make new friends</h1>
      <Appstore v-bind:pageName="'home'"/>
    </div>
    <CategoryFooter />
  </div>
</template>

<script>
import CategoryFooter from "../common/CategoryFooter.vue";
import Appstore from "../common/Appstore.vue";

export default {
  name: "home",

  components: {
    CategoryFooter,
    Appstore
  }
};
</script>

<style lang="stylus">
.home-page
  text-align center
  background #FFF
  position absolute
  top 0
  left 0
  width 100%
  min-height 100%
  display flex
  flex-direction column
  align-items center
  .home_mobile
    background #FFFC00
    width 100%
    height 80vh;
    h1
      padding: 0 20px
  .title
    font-family: Nunito
    font-style: normal
    font-weight: bold
    font-size: 36px
    line-height: 40px
    text-align: center;
    color: #000000;
    margin-top: 30px
  .logo
    width 136px
    margin-top 152px !important;

  .slogan
    height 80px
    margin-top 32px
.appstore
  margin: 64px auto
  position relative
  text-align center


  .download-guide
    text-align center
    position: absolute;
    top: 10px;
    width: 100%;
    img
      height 16px;
  .btn-download-group
    margin 36px auto 0
    padding: 0 0 10px 0
    img
      width 214px


.mobile .appstore a
  margin 0 auto
  display block
  font-size: 18px;
  line-height: 56px;
  text-align: center;
  font-weight bold
  height: 56px;
  width: 240px;
  border-radius: 32px;
  box-shadow: inset 0 -0.5px 0 0 rgba(208,214,217,0.75), 0 2px 8px 0 rgba(0,0,0,0.25);

  background-color: #ffffff;
  color #000000

</style>



// WEBPACK FOOTER //
// Home.vue